(function ($) {

    $('.button--purple').on('click',function() {
        console.log('button purple clicked');
        $('body, html').animate({
          scrollTop: $('#contact').offset().top-60
        }, 300); 
    });

})(jQuery);